
import MessageForm from "~/components/v2/message/message-form.vue";
import { mdiClose } from "@mdi/js";

export default {
  components: {
    MessageForm,
  },

  props: {
    fieldName: {
      type: String,
      required: false,
      default: "profile_id",
    },
    profile: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,

      mdiClose,
    };
  },

  computed: {
    recipientStr() {
      const { name, age, location, myDetails, city } = this.profile || {};

      return [name, age || myDetails?.[0]?.age, location?.[0]?.baseCity || city]
        .filter(Boolean)
        .join(", ");
    },
  },

  methods: {
    close() {
      this.isOpen = false;
    },

    menuStateCallback(val) {
      if (val === false) {
        this.$refs.MessageForm.clear();
      }
    },

    checkAuth() {
      if (!this.$auth.loggedIn) {
        this.$router.push({ name: "auth-signin" });
      }
    },
  },
};
